/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
const $ = require("jquery");
$.Datatable = require("datatables.net");
const WithdrawalReport = () => {
    const [user, setUser] = useState()
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    
    let baseUrl;
    if(nodeMode==="development"){
      baseUrl =  beckendLocalApiUrl;
    }else{
      baseUrl = beckendLiveApiUrl
    }
    //use for pagination..
    let [limit,setLimit] = useState(10);
  const setpageLimit = (event)=>{
    let key = event.target.value
    setLimit(key);
}
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [values, setValues] = useState([
        new DateObject().subtract(4, "days"),
        new DateObject().add(4, "days")
      ])
    //react paginate..
    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setPageNumber(currentPage);
      };
    
    const profle = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`txn/withdrawalreports/all?page=${pageNumber}&_limit=${limit}&FROM_DATE=${values[0]}&TO_DATE=${values[1]}`, { headers })
            .then((res) => {
                setUser(res.data.datefind)
                setNumberOfPages(res.data.totalPages)
            })
    }
    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('default', {year:'numeric', month: 'numeric', day: 'numeric' });
        return newDate;
    }
    useEffect(() => {
        profle()
    }, [pageNumber,limit,values])
    if (user === undefined) {
        return null
    }
    
const createDownloadData = () => {
  handleExport();
};
const handleExport = () => {
  let table1 = [
    {
      A: "Id",
      B: "UserName",
      C: "PhoneNumber",
      D: "Withdrawal Amount",
      E: "Status",
      F: "Upi Id",
      G: "Action by",
    },
  ];
  user.forEach((row) => {
    const userDetails = row;
    table1.push({
      A: userDetails._id,
      B: (userDetails.User_id)?userDetails.User_id.Name:'',
      C: (userDetails.User_id)?userDetails.User_id.Phone:'',
      D: userDetails.amount?userDetails.amount:'',
      E: userDetails.status?userDetails.status:'',
      F: userDetails.User_id.upi_id,
      G: (userDetails.action_by)?userDetails.action_by.Name:'N/A',
    });
  });
  const ws = XLSX.utils.json_to_sheet(table1, {
    skipHeader: true,
  });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
  XLSX.writeFile(wb, "WithdrawalReport.xlsx");
};
  // Styles
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
    
    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; display: flex; justify-content: space-between; align-items: center; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
    /* Controls Bar */
    .controls-bar { display: flex; gap: 15px; flex-wrap: wrap; padding: 20px; background: #fafafa; border-bottom: 1px solid #eee; align-items: center; }
    
    .btn-export { background: #27ae60; color: white; border: none; padding: 10px 20px; border-radius: 8px; font-weight: 600; cursor: pointer; transition: 0.2s; box-shadow: 0 4px 10px rgba(39, 174, 96, 0.2); }
    .btn-export:hover { background: #219150; transform: translateY(-2px); }
    .select-custom { padding: 8px 15px; border: 1px solid #ddd; border-radius: 8px; font-size: 0.9rem; background: white; outline: none;  }
    
    /* Table */
    .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
    .custom-table { width: 100%; border-collapse: collapse; min-width: 900px; }
    .custom-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px 20px; border-bottom: 2px solid #eee; text-align: left; }
    .custom-table tbody td { padding: 15px 20px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.9rem; }
    .custom-table tbody tr:hover { background: #fafafa !important; }
    
    .user-link { color: #57155a; text-decoration: none; font-weight: 600; background: #f3e5f5; padding: 5px 10px; border-radius: 6px; font-size: 0.85rem; }
    .user-link:hover { background: #e1bee7; }
    /* Pagination */
    .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
    .page-item { display: inline-block; }
    .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
    .page-link:hover { background: #f9f9f9; color: #57155a !important; border-color: #ddd; }
    .active .page-link { background: #57155a; color: white !important; border-color: #57155a; box-shadow: 0 4px 10px rgba(87, 21, 90, 0.3); }
    /* DatePicker Override */
    .rmdp-container { border: 1px solid #ddd; border-radius: 8px; overflow: hidden; }
    .rmdp-input { border: none; padding: 10px; width: 220px; text-align: center; font-family: 'Poppins', sans-serif; font-size: 0.9rem; outline: none; }
  `;
    return (
        <div className="admin-mgmt-page">
            <style>{styles}</style>
            
            <div className="row">
                <div className="col-12">
                    <div className="modern-card">
                        
                        <div className="card-header-custom">
                            <h4 className="card-title-custom">Withdrawal Reports</h4>
                            
                            <button onClick={createDownloadData} className="btn-export">
                                <i className="mdi mdi-download mr-1"></i> Export Data
                            </button>
                        </div>
                        <div className="controls-bar">
                             <DatePicker 
                                value={values} 
                                onChange={setValues} 
                                range 
                                inputClass="rmdp-input"
                             />
                             
                             <select className='select-custom' id='pagelimit' name='pagelimit' onChange={setpageLimit}>
                                  <option value="10">10 Rows</option>
                                  <option value="20">20 Rows</option>
                                  <option value="50">50 Rows</option>
                                  <option value="100">100 Rows</option>
                                  <option value="500">500 Rows</option>
                              </select>
                        </div>
                        <div className="table-responsive">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th> ID</th>
                                        <th> Phone</th>
                                        <th> User</th>
                                        <th> Withdrawal Type</th>
                                        <th> Payment ID</th>
                                        <th> Amount </th>
                                        <th> Status </th>
                                        <th> Date </th>
                                        <th> Action By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {user && user.map((data, key) => (
                                        <tr key={key}>
                                            <td style={{color:'#999', fontWeight:'bold'}}>{(pageNumber === 0 ? 0 : pageNumber - 1) * limit + (key + 1)}</td>
                                            
                                            <td><span style={{fontFamily:'monospace', color:'#666'}}>{data._id}</span></td>
                                            
                                            <td>
                                                <span style={{color:'#444'}}>{data.User_id ? data.User_id.Phone : '-'}</span>
                                            </td>
                                            
                                            <td>
                                                {data.User_id ? (
                                                     <Link className="user-link" to={`/user/view_user/${data.User_id._id}`} >{data.User_id.Name}</Link>
                                                ) : <span style={{color:'#999'}}>N/A</span>}
                                            </td>
                                            
                                            <td>
                                                <span style={{fontWeight:'500'}}>{data.Withdraw_type}</span>
                                            </td>
                                            <td>
                                                <span style={{color:'#666', fontSize:'0.85rem'}}>{data.User_id ? data.User_id.upi_id : '-'}</span>
                                            </td>
                                            
                                            <td style={{fontWeight:'700', color:'#27ae60'}}>₹{data.amount}</td>
                                            
                                            <td>
                                                <span style={{
                                                    background: (data.status==="SUCCESS")?'#e8f5e9':'#ffebee',
                                                    color: (data.status==="SUCCESS")?'#2e7d32':'#c62828',
                                                    padding:'4px 8px', borderRadius:'4px', 
                                                    fontSize:'0.75rem', fontWeight:'700', textTransform:'uppercase'
                                                }}>
                                                    {(data.status==="none") ? 'Processing' : data.status}
                                                </span>
                                            </td>
                                            
                                            <td style={{color:'#555', fontSize:'0.85rem'}}>{dateFormat(data.createdAt).split(',')[0]}</td>
                                            
                                            <td style={{fontWeight:'500', color:'#57155a'}}>{(data.action_by)?data.action_by.Name:'N/A'}</td>
                                        </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='p-3'>
                            <ReactPaginate
                                previousLabel={"← Prev"}
                                nextLabel={"Next →"}
                                breakLabel={"..."}
                                pageCount={numberOfPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default WithdrawalReport;